import {ValueDefinition} from '@/model/types';

export enum FeeType {
  RedemptionFees = 'DV-33#1',
  NoLoad = 'DV-33#2',
  ModerateRedemptionFees = 'DV-33#3',
  AdvisorChargeback3Years = 'DV-33#4',
  AdvisorChargeback5Years = 'DV-33#5',
}

export const DV_33 = {
  id: 'DV-33',
  description: {
    fr: 'Type de frais',
    en: 'Fee type',
  },
  type: 'FeeType',
  values: [
    {
      id: '1',
      value: {
        fr: 'Frais au rachat',
        en: 'Redemption fees',
      },
      properties: {
        id_beneva: '0',
        DtDb: '2007-12-03',
        DtFi: '2199-12-31',
      },
    },
    {
      id: '2',
      value: {
        fr: 'Sans frais de souscription',
        en: 'No-load fees',
      },
      properties: {
        id_beneva: '1',
        DtDb: '2007-12-03',
        DtFi: '2199-12-31',
      },
    },
    {
      id: '3',
      value: {
        fr: 'Frais au rachat modéré',
        en: 'Moderate Redemption fees',
      },
      properties: {
        id_beneva: '4',
        DtDb: '2007-12-03',
        DtFi: '2199-12-31',
      },
    },
    {
      id: '4',
      value: {
        fr: 'Récupération de commission – conseiller 3 ans',
        en: 'Advisor Chargeback 3 years',
      },
      properties: {
        id_beneva: '6',
        DtDb: '2018-04-23',
        DtFi: '2199-12-31',
      },
    },
    {
      id: '5',
      value: {
        fr: 'Récupération de commission – conseiller 5 ans',
        en: 'Advisor Chargeback 5 years',
      },
      properties: {
        id_beneva: '5',
        DtDb: '2018-04-23',
        DtFi: '2199-12-31',
      },
    },
  ],
} as const satisfies ValueDefinition;
